import React from "react";
import GalleryLayout from "./GalleryLayout";
import ThumbnailLayout from "./ThumbnailLayout";
import SpeakerLayout from "./SpeakerLayout";
import SideLayout from "./SideLayout";
import { ParticipantType, ShowLayout } from "@/types";
import DualLayout from "./DualLayout";

interface PropType {
  participants?: ParticipantType[];
  layout: ShowLayout;
  galleryPageSize: number;
}

const Content: React.FC<PropType> = (props: PropType) => {
  const { layout, participants = [], galleryPageSize } = props;
  console.log(`[Content] layout=${layout}`);
  if (participants.length === 0) {
    return (
      <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center", color: "#999" }}>
        等待其他成员加入会议
      </div>
    );
  }
  if (layout === ShowLayout.Speaker) {
    return <SpeakerLayout />;
  }
  if (layout === ShowLayout.Thumbnail) {
    return <ThumbnailLayout />;
  }
  if (layout === ShowLayout.Side) {
    return <SideLayout />;
  }
  if (layout === ShowLayout.Dual) {
    return <DualLayout />;
  }
  return <GalleryLayout pageSize={galleryPageSize} />;
};

export default Content;
